import { render, staticRenderFns } from "./message-send-relation.vue?vue&type=template&id=72319d00"
import script from "./message-send-relation.vue?vue&type=script&lang=ts"
export * from "./message-send-relation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports